import { FC } from "react";
import { countries } from "../../data/countries";
import Image from 'next/image';

type FlagProps = {
  country: string;
  width?: number | string;
  height?: number | string;
};

export const getFlagUrl = (alpha2Code: string) => `/flags/${alpha2Code}.svg`;

export const getAlpha2Code = (country: string) =>
  countries.find((c) => c.name === country)?.alpha2!;

const Flag: FC<FlagProps> = (props) => {
  return (
    <Image
      width={props.width || 20}
      height={props.height || 20}
      src={getFlagUrl(getAlpha2Code(props.country))}
      alt={`flagga ${props.country}`}
    />
  );
};

export default Flag;
